import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import AppMenu from "../../menu";
import TablesData from "../globalTable";
import TableItem from "../globalTable/tableItem";
import { SearchOnly } from "../globalTable/searchandfilter";
import HorizontalTabs from "../../tabs/horizontalTabs";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../common/Loader";
import { useStyles } from "../modals/modalContent";
import ReusableComprehensiveCostModal from "../modals/ReusableComprehensiveCostModal";
import {
  fetchComprehensiveCosts,
  getComprehensiveCosts,
} from "../../../store/comprehensiveCost";
import { axiosInstance } from "../../../utils/axiosInstance";

const tabLabels = ["Principal Directory", "Dependent Directory"];

export default function ComprehensiveCostTable() {
  const history = useHistory();
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const dispatch = useDispatch();
  const othersData = useSelector(getComprehensiveCosts);
  let [pageNumber, setPageNumber] = useState(1);
  let [pageLists, setPageLists] = useState(10);
  const { activetab } = useParams();
  const classes = useStyles();
  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    mode: null,
    providerData: null,
  });

  const tabNameToIndex = {
    0: "principal-directory",
    1: "dependent-directory",
  };

  const indexToTabName = {
    "principal-directory": 0,
    "dependent-directory": 1,
  };

  const [tabIndex, setTabIndex] = useState(indexToTabName[activetab] || 0);

  const onChangeTabIndex = (e, newValue) => {
    history.push(
      `/hmo/dashboard/comprehensive-cost/${tabNameToIndex[newValue]}`
    );
    setTabIndex(newValue);
  };

  useEffect(() => {
    dispatch(fetchComprehensiveCosts(pageLists, pageNumber));
  }, [dispatch, pageNumber, pageLists]);

  const incrementPageNumber = () => {
    setPageNumber((prev) => prev + 1);
  };

  const decrementPageNumber = () => {
    setPageNumber((prev) => Math.max(prev - 1, 1));
  };

  const handleSelectNumber = ({ target }) => {
    setPageLists(Number(target.value));
    setPageNumber(1);
  };

  const handleChange = (e) => {
    e.preventDefault();
    setSearch(e.target.value);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = [...selected, id];
    } else if (selectedIndex === 0) {
      newSelected = selected.slice(1);
    } else if (selectedIndex === selected.length - 1) {
      newSelected = selected.slice(0, -1);
    } else {
      newSelected = [
        ...selected.slice(0, selectedIndex),
        ...selected.slice(selectedIndex + 1),
      ];
    }

    setSelected(newSelected);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const handleSelectAllClick = () => {
    const newSelecteds =
      othersData?.ComprehensiveCostList?.map((n) => n.id) || [];
    setSelected(newSelecteds);
  };

  const handleDeleteHealthPlan = async (id) => {
    try {
      const response = await axiosInstance.delete(
        `/v1/admin/cost-centres/${id}`
      );
      if (response?.status) {
        dispatch(fetchComprehensiveCosts(pageLists, pageNumber));
      }
    } catch (error) {
      throw error;
    }
  };

  const handleEditHealthPlan = async (id, data) => {
    try {
      const response = await axiosInstance.put(
        `/v1/admin/cost-centres/${id}`,
        data
      );
      if (response) {
        dispatch(fetchComprehensiveCosts(pageLists, pageNumber));
      }
    } catch (error) {
      throw error;
    }
  };

  const openModal = (mode, providerData) => {
    setModalConfig({
      isOpen: true,
      mode,
      providerData,
    });
  };

  const closeModal = () => {
    setModalConfig({ isOpen: false, mode: null, providerData: null });
  };

  if (othersData?.error) {
    return (
      <div>Error: {othersData.error.message || "Failed to load data."}</div>
    );
  }

  const careList = othersData?.ComprehensiveCostList || [];
  if (careList.length === 0 && !othersData?.loading) {
    return <div>No comprehensive Cost found.</div>;
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          marginBottom: "2rem",
          justifyContent: "space-between",
        }}
      >
        <SearchOnly handleSearch={handleChange} searchWord={search} />
        <HorizontalTabs
          tabData={tabLabels}
          tabIndex={tabIndex}
          onTabChange={onChangeTabIndex}
        />
      </div>
      <Loader visible={othersData?.loading} />
      <ReusableComprehensiveCostModal
        isOpen={modalConfig.isOpen}
        onClose={closeModal}
        mode={modalConfig.mode}
        providerData={modalConfig.providerData}
        onSubmit={handleEditHealthPlan}
        onDelete={handleDeleteHealthPlan}
      />
      <TableItem
        userType="Comprehensive Cost Plan"
        checkBoxes
        tabHeadLabel={["Plan Name", "Price"]} // Updated to show Price instead of Tests
        action
        tableSize
        tabToolBar
        tabHeadCheck
        numSelectedItem={selected?.length || 0}
        rowCount={careList.length}
        numSelected={selected?.length || 0}
        onSelectAllClick={handleSelectAllClick}
        currentPage={othersData?.currentPage || 1}
        toPage={othersData?.toPage || 10}
        totalPage={othersData?.total || 0}
        handleIncrement={incrementPageNumber}
        handleDecrement={decrementPageNumber}
        disabledIncrement={pageNumber >= (othersData?.lastPage || 1)}
        disabledDecrement={pageNumber <= 1}
        handleSelectPageNumber={handleSelectNumber}
        pageSelectValue={pageLists}
        tabBodyData={careList
          .filter(
            (item) =>
              item.name.toLowerCase().includes(search.toLowerCase()) ||
              String(item.price).includes(search.toLowerCase()) // Filter by price
          )
          .map((item, i) => {
            const isItemSelected = isSelected(item.id);
            const labelId = `enhanced-table-checkbox-${i}`;
            return (
              <TablesData
                labelId={labelId}
                handleItemClick={(event) => handleClick(event, item.id)}
                aria-checked={isItemSelected}
                isItemSelected={isItemSelected}
                key={i}
                checkBoxes
                image
                imgInitials={item?.name?.slice(0, 2)}
                enroleeName={item?.name}
                enroleeId={item?.id}
                listItem={[
                  <div className={classes.flexBox}>
                    <span className={classes.testTag}>{item.price}</span> 
                  </div>,
                ]}
                action={
                  <AppMenu
                    menu_name_or_icon={<MoreHorizIcon />}
                    item_names={[
                      { View: () => openModal("view", item) },
                      { Edit: () => openModal("edit", item) },
                      { Delete: () => openModal("delete", item) },
                    ]}
                  />
                }
              />
            );
          })}
        tablePagination
      />
    </>
  );
}
